import state from './moduleBankTransfersState.js'
import mutations from './moduleBankTransfersMutations.js'
import actions from './moduleBankTransfersActions.js'
import getters from './moduleBankTransfersGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
